import React from "react";
import { ExternalDirectiveResearch } from "./ExternalDirectiveResearch";

export const RedResearch = () => (
  <ExternalDirectiveResearch
    eurLexUrl="https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX:32014L0053"
    i18nPrefix="steps.questionaire.red.research"
  />
);
